import React from 'react';
import { CheckIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
const timeline: {
  label: string;
  time: string;
  done: boolean;
}[] = [{
  label: 'Sent',
  time: '8:17 PM',
  done: false
}, {
  label: 'Reminder',
  time: '9:00 AM',
  done: false
}, {
  label: 'Signed',
  time: '9:24 AM',
  done: true
}];
export function AgreementVignette() {
  return <VignetteFrame label="E-signature" timestamp="Sam T." data-id="element-246" data-mp="1xftz9d32oajr">
      <Reveal className="flex items-start gap-3" data-id="element-247" data-mp="1sgqt1pbcvya7">
        <span className="flex h-10 w-10 flex-none items-center justify-center rounded-lg border border-white/10 bg-ink-700" data-id="element-248" data-mp="1si0qccadx2fs">
          <FileTextIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-249" data-mp="1jox5hixetnb4" />
        </span>
        <div data-id="element-250" data-mp="1jn48ywgigjgu">
          <p className="font-display text-base font-semibold text-white" data-id="element-251" data-mp="2g6l35z4aj8qr">
            Buyer Touring Agreement
          </p>
          <p className="mt-1 text-xs text-white/45" data-id="element-252" data-mp="2bfuvugcb0vtf">
            East Cactus tour, Saturday 10:00 AM
          </p>
        </div>
      </Reveal>

      <ol className="mt-6 space-y-4" data-id="element-253" data-mp="uf3jqkmar456">
        {timeline.map((item, index) => <li key={item.label} data-id="element-254" data-mp="zbk7hdpl3ghq" data-mpi={index}>
            <Reveal delay={0.2 + index * 0.22} offset={8} className="flex items-center gap-3" data-id="element-255" data-mp="zdxztesvqell">
              <span className={`flex h-6 w-6 flex-none items-center justify-center rounded-full border ${item.done ? 'border-brand bg-brand text-ink-900' : 'border-white/20 bg-ink-700 text-white/40'}`} data-id="element-256" data-mp="klcwtk5tj1rl">
                {item.done ? <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-257" data-mp="1p4m40u1dyow" /> : <span className="h-1.5 w-1.5 rounded-full bg-current" data-id="element-258" data-mp="6mmr5g4xntrm" />}
              </span>
              <span className={`text-sm font-medium ${item.done ? 'text-white' : 'text-white/65'}`} data-id="element-259" data-mp="1w3fbqbiggwvq">
                {item.label}
              </span>
              <span className="ml-auto text-xs tabular-nums text-white/40" data-id="element-260" data-mp="1zluzji0zrsv2">
                {item.time}
              </span>
            </Reveal>
          </li>)}
      </ol>

      <Reveal delay={0.9} className="mt-6 flex items-start gap-3 rounded-xl border border-white/10 bg-ink-700 px-4 py-3" data-id="element-261" data-mp="1pn5jzvwkikhz">
        <ShieldCheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-262" data-mp="1lmvd8h0ybq22" />
        <p className="text-xs leading-relaxed text-white/60" data-id="element-263" data-mp="2dbydllppwg9f">
          Your brokerage&rsquo;s form, sent automatically.
        </p>
      </Reveal>
    </VignetteFrame>;
}